<template>
  <div class="paper-background">
    <div class="paper-banner">
      <div class="paper-container">
        <div class="paper-banner-title">论文</div>
      </div>

      <img class="paper-banner-img" src="../../assets/about/banner.png" />
    </div>
    <div class="paper-container">
      <div class="paper-content">
        <div class="paper-content-title">
          <div class="paper-content-title-text">PWmat相关文献</div>
        </div>
        <div class="paper-content-info">
          <p class="paper-content-info-text">
            下面的表格中我们列出了和PWmat相关的文献供用户研究参考：
          </p>
        </div>

        <!--        <div class="paper-el-link">
         <el-link type="primary" :disabled="true" v-for="(year, key) in years" :key="key" @click="yearPaper(key)">{{year}}年</el-link>
       </div> -->

        <div class="btn-group" role="group" aria-label="Basic example">
          <button
            v-for="(year, key) in years"
            :key="key"
            :ref="'btn'+key"
            type="button"
            class="btn btn-secondary"
            @click="yearPaper(key)"
          >
            20{{ year }}年
          </button>
        </div>

        <div class="paper-content-info">
          <p class="paper-content-info-text">20{{ currentYear }}年</p>
          <table class="paper-table">
            <tr
              class="paper-td"
              v-for="(paper, index) in currentPaper"
              :key="index"
            >
              <td class="paper-text-td">{{ index + 1 }}</td>
              <td class="paper-text-td" width="25%">{{ paper.author }}</td>
              <td class="paper-text-td" width="55%">
                <a class="paper-a" :href="paper.url" target="_blank">{{
                  paper.summary
                }}</a>
              </td>
              <td class="paper-text-td" width="20%">{{ paper.time }}</td>
            </tr>
          </table>
        </div>
<!--
        <div v-show="true" class="paper-content-info">
          <p class="paper-content-info-text">2016年</p>
          <table class="paper-table">
            <tr class="paper-td" v-for="(paper, index) in paper16">
              <td class="paper-text-td">{{ index + 1 }}</td>
              <td class="paper-text-td" width="25%">{{ paper.author }}</td>
              <td class="paper-text-td" width="55%">
                <a class="paper-a" :href="paper.url" target="_blank">{{
                  paper.summary
                }}</a>
              </td>
              <td class="paper-text-td" width="20%">{{ paper.time }}</td>
            </tr>
          </table>
        </div>
 -->

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PaperPage",
  data() {
    return {
      years: [24, 23, 22, 21, 20, 19, 18, 17, 16],
      currentYear: null,
      currentPaper: null,
    };
  },
  computed: {
    ...mapState({
      paper16: (state) => state.Paper.paper16.info,
      paper17: (state) => state.Paper.paper17.info,
      paper18: (state) => state.Paper.paper18.info,
      paper19: (state) => state.Paper.paper19.info,
      paper20: (state) => state.Paper.paper20.info,
      paper21: (state) => state.Paper.paper21.info,
      paper22: (state) => state.Paper.paper22.info,
      paper23: (state) => state.Paper.paper23.info,
      paper24: (state) => state.Paper.paper24.info,
    }),
  },
  created() {
    this.$store.dispatch("getPaper16").then((res) => {});
    this.$store.dispatch("getPaper17").then((res) => {});
    this.$store.dispatch("getPaper18").then((res) => {});
    this.$store.dispatch("getPaper19").then((res) => {});
    this.$store.dispatch("getPaper20").then((res) => {});
    this.$store.dispatch("getPaper21").then((res) => {});
    this.$store.dispatch("getPaper22").then((res) => {});
    this.$store.dispatch("getPaper23").then((res) => {});
    this.$store.dispatch("getPaper24").then((res) => {
      this.currentPaper = this.paper24;
      // console.log("paper22", this.paper22);
    });
    this.currentYear = this.years[0];
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.currentYear = this.years[0];
    //   this.currentPaper = this.paper22;
    //   console.log("paper22", this.paper22);
    //   console.log("this.currentPaper", this.currentPaper);
    // });
    // setTimeout(() => {
    // }, 3000)
    this.$refs["btn0"][0].focus()
  },
  methods: {
    yearPaper(key) {
      console.log(key);
      this.currentYear = this.years[key];
      this.currentPaper = eval("this.paper"+this.years[key])
    },
  },
};
</script>

<style scoped>
.paper-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.paper-background {
  margin-top: 70px;
}
.paper-banner {
  overflow: hidden;
}
.paper-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.paper-banner-img {
  min-width: 100%;
  height: 165px;
}
.paper-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.paper-content-title {
  padding-top: 50px;
  text-align: center;
}
.paper-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.paper-content-info {
  margin-top: 50px;
}
.paper-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.paper-content-info {
  margin-top: 40px;
}
.paper-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}
.paper-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}
.paper-td {
  height: 45px;
}
.paper-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding-left: 16px;
}
.paper-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 14px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding: 4px 8px;
  word-wrap: break-word;
}
.paper-a {
  color: rgba(73, 145, 201, 1) !important;
  cursor: pointer;
}
@media screen and (max-width: 482px) {
  .paper-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .paper-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .paper-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .paper-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .paper-container {
    max-width: 1068px;
  }
}
.btn-secondary {
    color: #fff;
    background-color: rgba(73, 145, 201, 1);
    border-color: rgba(73, 145, 201, 1);
}
</style>
